import React from "react";

export default function PreviewBox({ imagePreview, progressText }) {
  return (
    <div className="border p-4 bg-white shadow rounded mt-4">
      {imagePreview ? (
        <img src={imagePreview} alt="Preview" className="w-full rounded" />
      ) : (
        <p className="text-gray-500 text-sm">{progressText}</p>
      )}
    </div>
  );
}
